export default {"breadcrumb":"ch9M5q_breadcrumb","actions":"ch9M5q_actions","form":"ch9M5q_form",}